import { ApiService } from 'src/app/services/api.service';

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-ticket-swap',
  templateUrl: './ticket-swap.component.html',
  styleUrls: ['./ticket-swap.component.scss'],
})
export class TicketSwapComponent implements OnInit {
  @Input() ticket;

  constructor(private modalController: ModalController, private apiService: ApiService) {}

  ngOnInit() {
    console.log(this.ticket);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  pay() {
    console.log('Pay clicked!');
    this.modalController.dismiss({
      pay: true,
    });
  }
}
